import { MenuItem, Select, Tooltip } from '@mui/material';
import { bgColorsVars } from '@design-system/vars.css';
import { tierOptions } from '../admin/administrationConfig';
import { FieldError } from 'react-hook-form';
import { Typography } from '@design-system/components/typography/typography';

export const tierTooltipText: Record<number, string> = {
  1: 'Legacy creators that received “free” onboarding, design/programming services and/or custom landing page',
  2: 'Creators that paid for coaching services + receive help with onboarding, design/programming services and/or custom landing page',
  3: 'Creators that paid for coaching services only',
};

export const FormTier = ({
  value,
  onChange,
  error,
}: {
  value: number | null;
  onChange: (value: number) => void;
  error: FieldError | undefined;
}) => {
  return (
    <div>
      <Select
        error={!!error}
        displayEmpty={true}
        value={value}
        renderValue={(value: string | number | null) =>
          value ? tierOptions.find((i) => i.value === value)?.label : 'Select'
        }
        sx={{ width: '100%' }}
      >
        {tierOptions.map((option) => (
          <MenuItem
            key={option.label}
            value={option.value}
            id={`select-${option.value}`}
            onClick={() => onChange(option.value)}
          >
            <Tooltip
              title={tierTooltipText?.[option.value as number] || ''}
              key={option.label}
              placement="right"
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: bgColorsVars['N-40'],
                    color: 'black',
                    fontSize: '14px',
                    fontWeight: 500,
                    fontFamily: 'inherit',
                    padding: '4px 8px',
                  },
                },
              }}
            >
              <Typography variant="body" size="medium" className="w-full">
                {option.label}
              </Typography>
            </Tooltip>
          </MenuItem>
        ))}
      </Select>
    </div>
  );
};
